import { User } from "@/lib/store/features/auth/authSlice";

const canAccessAdmin = (user: User) => {
	return user.roles.includes("ADMIN") || user.roles.includes("SYSTEM_ADMIN");
};

const canAccessSearch = (user: User) => {
	return (
		user.roles.includes("ELASTIC_SEARCH") || user.roles.includes("SYSTEM_ADMIN")
	);
};

export { canAccessAdmin, canAccessSearch };
